import {nachweisTypes} from 'ag-common/tools/nachweisTypConstants'

const base = [
  {value: nachweisTypes.WEEKLY, label: 'Wöchentlich', hasQualifications: false},
  {value: nachweisTypes.DAILY, label: 'Täglich', hasQualifications: false},
  {value: nachweisTypes.MONTHLY, label: 'Monatlich', hasQualifications: false},
  {
    value: nachweisTypes.WEEKLY_WITH_QUALIFICATION,
    label: 'Wöchentlich mit Verweis',
    hasQualifications: true,
  },
  {
    value: nachweisTypes.DAILY_WITH_QUALIFICATION,
    label: 'Täglich mit Verweis',
    hasQualifications: true,
  },
]
function mapWithoutRedundantAttributes(x) {
  return {value: x.value, label: x.label}
}

export const options = base.map(mapWithoutRedundantAttributes)
export const optionsWithoutQualifikationen = base
  .filter(x => x.hasQualifications === false)
  .map(mapWithoutRedundantAttributes)

export function useNachweisTypes(includeQualificatinos, currentlySelected) {
  let optionsToUse = []
  if (includeQualificatinos) {
    optionsToUse = optionsToUse.concat(options)
  } else {
    optionsToUse = optionsToUse.concat(optionsWithoutQualifikationen)
  }
  if (currentlySelected && !optionsToUse.find(x => x.value === currentlySelected.value)) {
    optionsToUse.push(currentlySelected)
  }
  return optionsToUse
}
